module.exports = __webpack_public_path__ + "static/img/PAUL_REIFFEL.d1d07b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PAUL_REIFFEL.jpg
// module id = mTUe
// module chunks = 0